module.exports = __webpack_public_path__ + "static/benchmarking 1-02d0437dafb326f8f5ef358686c8990e.png";